var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subscription-homepage" },
    [
      _c(
        "div",
        { staticClass: "trial-panel" },
        [
          _c(
            "div",
            { staticClass: "logo-block" },
            [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.user,
                      expression: "!user",
                    },
                  ],
                  staticClass: "logo-link",
                },
                [
                  _c("rt-picture", {
                    attrs: { src: "/assets/app/class/icon-logo-white.svg" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("rt-picture", {
                staticClass: "icon-flag",
                attrs: { src: "/assets/app/class/icon-flag.svg" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.tableOptions.banner_image_url
            ? _c("rt-picture", {
                staticClass: "icon-confetti",
                attrs: { src: "/assets/app/class/icon-confetti.svg" },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.tableOptions.show_title
            ? _c("div", { staticClass: "header-block" }, [
                !_vm.yearly
                  ? _c("h2", { staticClass: "header-title" }, [
                      _vm._v(_vm._s(_vm.tableOptions.title)),
                    ])
                  : _c("h2", { staticClass: "header-title" }, [
                      _vm._v("Get ReadTheory for your school"),
                    ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.tableOptions.banner_image_url
            ? _c(
                "div",
                {
                  staticClass: "pricing-banner-wrapper",
                  class: { "no-subtitle": !_vm.tableOptions.sub_title },
                },
                [
                  _c("img", {
                    staticClass: "pricing-custom-banner",
                    attrs: { src: _vm.tableOptions.banner_image_url },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.yearly
            ? _c("p", { staticClass: "header-description" }, [
                _vm._v(_vm._s(_vm.tableOptions.sub_title)),
              ])
            : _c("p", { staticClass: "header-description" }, [
                _vm._v(
                  "Includes all our advanced features for schools, teachers, and students"
                ),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "video-block" },
        [
          !_vm.yearly
            ? _c("subscription-plan-view", {
                staticClass: "subscription-view",
                class: {
                  "has-banner": _vm.tableOptions.banner_image_url,
                  "without-title":
                    _vm.tableOptions.banner_image_url &&
                    !_vm.tableOptions.show_title,
                },
                attrs: { pricingTable: true },
                on: {
                  freePlanSelected: _vm.handleSelectFreePlan,
                  pricingChanged: _vm.handleChangePlan,
                  onGetQuote: _vm.showQuoteModal,
                },
              })
            : _c("yearly-subscription-plan-view", {
                staticClass: "subscription-view",
                class: {
                  "has-banner": _vm.tableOptions.banner_image_url,
                  "without-title":
                    _vm.tableOptions.banner_image_url &&
                    !_vm.tableOptions.show_title,
                },
                attrs: { pricingTable: true },
                on: {
                  freePlanSelected: _vm.handleSelectFreePlan,
                  pricingChanged: _vm.handleChangePlan,
                },
              }),
          _vm._v(" "),
          _vm.tableOptions.feature_highlight_widget
            ? _c("subscription-lesson-plan", {
                staticClass: "lesson-block",
                attrs: { pricingName: _vm.pricingRoleName },
                on: { onShowPlan: _vm.gotoPlanSection },
              })
            : _c("subscription-satisfaction", {
                staticClass: "guarante-block",
              }),
          _vm._v(" "),
          _c("div", { staticClass: "premium-video-block flex-wrapper" }, [
            _c("div", { staticClass: "video-title" }, [
              _vm._v("Curious about the perks of Pro?"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "video-subtitle" }, [
              _vm._v("See the difference in the quick video"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-image" },
              [
                _c("img", {
                  staticClass: "video-bg",
                  attrs: { src: "/assets/app/signup/video-slide.png" },
                }),
                _vm._v(" "),
                _c(
                  "primary-button",
                  {
                    staticClass: "video-btn",
                    on: {
                      click: function ($event) {
                        _vm.isVideoVisible = true
                      },
                    },
                  },
                  [
                    _c("rt-picture", {
                      staticClass: "video-btn-icon",
                      attrs: { src: "/assets/app/signup/icon_play.svg" },
                    }),
                    _vm._v("\n            Watch Video\n          "),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "review-block" }, [
        _c("h2", { staticClass: "review-title" }, [
          _vm._v("Reviews from happy users"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "carousel-wrapper" },
          [
            _c(
              "primary-button",
              {
                staticClass: "btn-prev btn-normal",
                on: { click: _vm.handleClickPrev },
              },
              [
                _c("rt-picture", {
                  attrs: { src: "/assets/app/class/icon-arrow-left.svg" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "carousel",
              {
                attrs: {
                  "per-page": 1,
                  "navigate-to": _vm.navigate,
                  "mouse-drag": false,
                  speed: 1000,
                  paginationEnabled: false,
                },
              },
              _vm._l(_vm.reviewers, function (reviewerItem, idx) {
                return _c(
                  "slide",
                  { key: idx },
                  [
                    _c("SubscriptionReviewCard", {
                      attrs: { reviewer: reviewerItem },
                    }),
                  ],
                  1
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "primary-button",
              {
                staticClass: "btn-next btn-normal",
                on: { click: _vm.handleClickNext },
              },
              [
                _c("rt-picture", {
                  attrs: { src: "/assets/app/class/icon-arrow-right-blue.svg" },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "slide-avatar-wrapper" },
          _vm._l(_vm.reviewers, function (reviewerItem, idx) {
            return _c("img", {
              key: idx,
              staticClass: "avatar-icon",
              class: { inactive: _vm.navigate !== idx },
              attrs: { src: reviewerItem.icon },
              on: {
                click: function ($event) {
                  _vm.navigate = idx
                },
              },
            })
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "features-block" },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm._l(_vm.featureDetails, function (detail, index) {
            return _c("div", { key: index, staticClass: "feature-details" }, [
              _c("img", {
                staticClass: "feature-image",
                attrs: { src: detail.img },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "feature-description" },
                [
                  _c("h3", { staticClass: "feature-title" }, [
                    _vm._v(_vm._s(detail.title)),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "feature-text" }, [
                    _vm._v(_vm._s(detail.text)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "primary-button",
                    {
                      staticClass: "feature-btn",
                      on: { click: _vm.gotoPlanSection },
                    },
                    [_vm._v("Choose your plan")]
                  ),
                ],
                1
              ),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("SubscriptionFooter", { attrs: { withOption: true } }),
      _vm._v(" "),
      _c("SubscriptionVideoModal", {
        attrs: { show: _vm.isVideoVisible },
        on: {
          close: function ($event) {
            _vm.isVideoVisible = false
          },
          onShowPlan: _vm.gotoPlanSection,
        },
      }),
      _vm._v(" "),
      _c("QuoteRequestModal", {
        attrs: { show: _vm.isQuoteModalOpened },
        on: { onClose: _vm.closeQuoteModal },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "feature-block-title" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v("Get more power to deeply engage students in reading."),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sub-title" }, [
        _vm._v("Explore the "),
        _c("span", [_vm._v("Premium")]),
        _vm._v(" ReadTheory Experience"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }